import { Alert, Select, SelectOption, Text } from '@amzn/meridian';
import type { LanguageSelectOption } from '../useMultiCreativeCampaignContent';

type FlavorLanguageSelectorProps = {
  languageSelectOptions: LanguageSelectOption[];
  selectedLanguageOptionValue: LanguageSelectOption['value'] | undefined;
  onSelectLanguageOption: (value: LanguageSelectOption['value']) => void;
};

export const FlavorLanguageSelector = ({
  languageSelectOptions,
  selectedLanguageOptionValue,
  onSelectLanguageOption,
}: FlavorLanguageSelectorProps) => {
  if (languageSelectOptions.length < 1) return null;
  return (
    <Select label="Language" minWidth={170} onChange={onSelectLanguageOption} size="xlarge" value={selectedLanguageOptionValue}>
      {languageSelectOptions.map((option) => (
        <SelectOption key={option.value} label={option.label} value={option.value}>
          {({ preselected, selected }) => (
            <>
              <Text>{option.label}</Text>
              {option.errorCount > 0 && (
                <Alert size="small" type="error">
                  <span
                    style={{
                      color: preselected || selected ? 'white' : 'unset',
                    }}
                  >
                    {option.errorCount} {option.errorCount === 1 ? 'error' : 'errors'}
                  </span>
                </Alert>
              )}
            </>
          )}
        </SelectOption>
      ))}
    </Select>
  );
};
